import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15597">
      <span className="sr-only" data-id="element-15598">Loading payment requests…</span>
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-15599">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-15600" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-15601" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-15602">
        <div className="flex gap-8" data-id="element-15603">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-15604">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15605" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15606">
        <div className="space-y-6" data-id="element-15607">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15608">
            <div data-id="element-15609">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-15610" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-15611" />
            </div>
            <div data-id="element-15612">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15613" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-15614" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-15615">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-15616" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-15617" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15618">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-15619">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-15620" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-15621" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-15622">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-15623" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-15624" />
      </div>
    </div>;
}